import React from 'react';
import './styles.scss';
import { CartIcon, CartLgIcon } from 'components/Atoms/Icon';
import { Badge, Empty, Popover } from 'antd';
import withCart from 'hooks/withCart';
import { CartItem } from 'components/Organisms';
import { useCurrencyConversion } from 'hooks/useCurrencyConversion';
import { MyButton } from 'components/Atoms';
import { Link } from 'react-router-dom';
import { CART } from 'routers/route-path';
import { FormattedMessage } from 'react-intl';

const CartPopover = ({ cart = [], cartTotalPrice }) => {
  const { formatWithConversion } = useCurrencyConversion(cartTotalPrice);
  if (!cart.length) {
    return (
      <Empty
        className="p-20"
        image={<CartLgIcon />}
        imageStyle={{ width: '184px' }}
        description={<FormattedMessage id="cart.empty" defaultMessage="Your cart is empty." />}
      />
    );
  }

  return (
    <div className="cart-popover">
      <div className="cart-popover-list border-bottom-placeholder">
        {cart?.map((item) => (
          <CartItem key={item.id} item={item} />
        ))}
      </div>
      <div className="mt-20 total-wrapper">
        <span className="total"><FormattedMessage id="cart.total" defaultMessage="Total: " /></span>
        <span className="totalPrice">{formatWithConversion(cartTotalPrice)}</span>
      </div>
      <div className="p-20">
        <Link to={CART}>
          <MyButton className="btn-primary-custom w-100p h-45">
            <FormattedMessage id="cart.go_to_cart" defaultMessage="Go To Cart" />
          </MyButton>
        </Link>
      </div>
    </div>
  );
};

const CartBadge = ({ cart = [], cartTotalPrice }) => {
  return (
    <Popover
      content={
        <CartPopover
          cart={Array.isArray(cart) ? cart : []}
          cartTotalPrice={cartTotalPrice}
        />
      }
      overlayClassName="cart-popover-overlay"
      arrowPointAtCenter
      placement="bottomRight"
    >
      <Badge className="action" count={cart.length}>
        <div className="cart-icon-wrapper flex-center align-items-center">
          <CartIcon title="Cart" />
        </div>
      </Badge>
    </Popover>
  );
};

export default withCart(CartBadge);
